module.exports = __webpack_public_path__ + "static/img/flowIcon1.ad43a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flowIcon1.png
// module id = fLqJ
// module chunks = 1